export const average = (arr) =>
arr.reduce((acc, cur) => acc + cur / arr.length, 0);